<div class="incoming-call-card"
     [class.incoming-call-card--minimized]="minimized"
     [class.incoming-call-card--dragging]="isDragging"
     [class.incoming-call-card--secondary]="isSecondary"
     [style.left.px]="minimized || isSecondary ? null : position.x"
     [style.right.px]="minimized || !isSecondary ? null : position.x"
     [style.top.px]="minimized ? null : position.y">

    <div class="incoming-call-card__header" [class.is-hidden]="minimized">
        <div class="incoming-call-card__drag-handle" (mousedown)="onDragStart($event)">
            <span class="drag-dots">⠿</span>
        </div>
        <button class="incoming-call-card__close" type="button" (click)="minimizeCard()">
            ×
        </button>
    </div>

    <div class="incoming-call-card__content" [class.is-hidden]="minimized">
        <div class="incoming-call-card__video-container" (click)="autoplayBlocked ? resumePlayback() : viewCall($event)">
            <video #videoElem autoplay playsinline muted (loadeddata)="onLoad()"></video>
            <div class="incoming-call-card__video-placeholder rtc-video-placeholder-bg" [@curtainOpen]="showPlaceholder ? 'show' : 'hide'">
                <div class="camera-off-icon">
                    <svg-icon src="assets/icons/ic_camera_off.svg"></svg-icon>
                </div>
            </div>
            <div class="incoming-call-card__autoplay-overlay" *ngIf="autoplayBlocked" (click)="resumePlayback(); $event.stopPropagation()">
                <div class="autoplay-icon">
                    <svg-icon src="assets/icons/ic_sound_off.svg"></svg-icon>
                </div>
                <div class="autoplay-text">{{ 'Call.TapToEnableAudio' | i18next }}</div>
            </div>
        </div>

        <div class="incoming-call-card__footer">
            <div class="call-info">
                <ng-container *ngIf="!retrievingCardData; else shimmerTpl">
                    <div class="caller">{{ caller ? caller.toUpperCase() : "" }}</div>
                    <div class="destination">{{ destination ? destination.toUpperCase() : "" }}</div>
                </ng-container>

                <ng-template #shimmerTpl>
                    <div class="shimmer-lines" aria-hidden="true">
                        <div class="shimmer-line shimmer-line--large"></div>
                        <div class="shimmer-line shimmer-line--small"></div>
                    </div>
                </ng-template>
            </div>
            <div class="incoming-call-card__actions">
                <dx-button *ngIf="isIncoming" (click)="answerCall($event)" type="success" [icon]="'assets/icons/ic_phone_call.svg'"></dx-button>
                <dx-button (click)="rejectCall($event)" type="danger" [icon]="'assets/icons/ic_phone_call.svg'"></dx-button>
            </div>
        </div>
    </div>

    <div class="incoming-call-card__minimized" [class.is-hidden]="!minimized">
        <div class="incoming-call-card__minimized-left">
            <div>{{ destination ? destination!.toUpperCase() : "" }}</div>
        </div>
        <div class="incoming-call-card__minimized-actions">
            <dx-button *ngIf="isIncoming" (click)="answerCall($event)" type="success" [icon]="'assets/icons/ic_phone_call.svg'"></dx-button>
            <dx-button (click)="rejectCall($event)" type="danger" [icon]="'assets/icons/ic_phone_call.svg'"></dx-button>
            <button type="button" class="incoming-call-card__restore" (click)="restoreCard()">⤢</button>
        </div>
    </div>

</div>
